import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/lib/motion";

export default function LegalShell({ eyebrow, title, updated, children, testId, compact }) {
  return (
    <div data-testid={testId} className={`relative pt-40 lg:pt-32 ${compact ? "pb-4" : "min-h-screen pb-28"}`}>
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-80 spotlight opacity-60" />
      <div className="mx-auto max-w-3xl px-5 lg:px-8">
        <Reveal>
          <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm text-white/50 transition-colors hover:text-white">
            <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
          </Link>
          <div className="mb-3 text-xs uppercase tracking-[0.3em] text-[#8B5CF6]">{eyebrow}</div>
          <h1 className="font-display text-4xl font-bold tracking-tighter text-white sm:text-5xl">{title}</h1>
          {updated && <p className="mt-4 text-sm text-white/40">Stand: {updated}</p>}
        </Reveal>

        <Reveal delay={0.1}>
          <div className="legal-body mt-12 space-y-8 text-[15px] leading-relaxed text-white/60">
            {children}
          </div>
        </Reveal>
      </div>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section className="space-y-3">
      <h2 className="font-display text-xl font-semibold text-white">{title}</h2>
      {children}
    </section>
  );
}
